export default {"section":"IUdeu","sectionTitle":"neoYr","sectionDescription":"GVAFZ","accordionContent":"phCYi","link":"TDIxw"};